import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useCart } from '../contexts/CartContext';
export function OptionsTable() {
  const {
    addToCart
  } = useCart();
  const options = [{
    name: 'Hair Transplant (FUE/FUT)',
    cost: '$10,000–$30,000',
    risk: 'Permanent shock loss, scarring, finite donor supply, surgical complications.',
    outcome: 'One-time procedure, limited by donor hair, may need multiple sessions.',
    highlight: false
  }, {
    name: 'Finasteride (Daily Pill)',
    cost: '$600–$1,200+ per year',
    risk: 'Sexual side effects (documented), hormonal changes, lifelong dependency.',
    outcome: 'Slows loss for some, requires daily commitment, effects stop if discontinued.',
    highlight: false
  }, {
    name: 'Generic Laser Caps',
    cost: '$300–$800',
    risk: 'Wasted time and money, wrong wavelength, no clinical backing, no tracking.',
    outcome: "Vague promises, under-dosed, no proof it's working, on your head,",
    highlight: false
  }, {
    name: 'CrownControl™',
    cost: '$497 one-time',
    risk: 'None — 180-day money-back guarantee if no visible improvement',
    outcome: "Clinical dosing, photo-based tracking, know if it's working months not years own it forever,",
    highlight: true
  }];
  return <section className="w-full bg-gray-50 py-20 px-4" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-154">
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-155">
            Your Options
          </h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto" data-id="element-156">
            The math is simple. CrownControl™ gives you proof without the risk.
          </p>

          {/* Table - Mobile: Cards, Desktop: Table */}
          <div className="hidden md:block overflow-x-auto" data-id="element-157">
            <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-158">
              <thead data-id="element-159">
                <tr className="bg-gray-100" data-id="element-160">
                  <th className="text-left p-4 font-bold text-gray-900" data-id="element-161">
                    Option
                  </th>
                  <th className="text-left p-4 font-bold text-gray-900" data-id="element-162">
                    Cost (3 Years)
                  </th>
                  <th className="text-left p-4 font-bold text-gray-900" data-id="element-163">
                    What You Risk
                  </th>
                  <th className="text-left p-4 font-bold text-gray-900" data-id="element-164">
                    What You Get
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-165">
                {options.map((option, index) => <motion.tr key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.3,
                delay: index * 0.1
              }} className={`border-t border-gray-200 ${option.highlight ? 'bg-red-50 border-l-4 border-l-brand-red' : ''}`} data-id="element-166">
                    <td className="p-4 font-semibold text-gray-900" data-id="element-167">
                      {option.name}
                    </td>
                    <td className="p-4 text-gray-700 font-medium" data-id="element-168">
                      {option.cost}
                    </td>
                    <td className="p-4 text-gray-600 text-sm" data-id="element-169">{option.risk}</td>
                    <td className="p-4 text-gray-600 text-sm" data-id="element-170">
                      {option.outcome}
                    </td>
                  </motion.tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4" data-id="element-171">
            {options.map((option, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} className={`bg-white rounded-lg p-6 shadow-sm ${option.highlight ? 'border-2 border-brand-red' : 'border border-gray-200'}`} data-id="element-172">
                <h3 className="font-bold text-gray-900 text-lg mb-3" data-id="element-173">
                  {option.name}
                </h3>
                <div className="space-y-3 text-sm" data-id="element-174">
                  <div data-id="element-175">
                    <span className="font-semibold text-gray-700" data-id="element-176">Cost: </span>
                    <span className="text-gray-600" data-id="element-177">{option.cost}</span>
                  </div>
                  <div data-id="element-178">
                    <span className="font-semibold text-gray-700" data-id="element-179">Risk: </span>
                    <span className="text-gray-600" data-id="element-180">{option.risk}</span>
                  </div>
                  <div data-id="element-181">
                    <span className="font-semibold text-gray-700" data-id="element-182">
                      Outcome:{' '}
                    </span>
                    <span className="text-gray-600" data-id="element-183">{option.outcome}</span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* CTA */}
          <div className="mt-12 flex flex-col items-center gap-4" data-id="element-184">
            <CTAButton variant="primary" onClick={addToCart} ariaLabel="Start the 180-Day CrownControl Protocol" data-id="element-185">
              Start the 180-Day CrownControl Protocol
            </CTAButton>
            <p className="text-sm text-gray-600" data-id="element-186">
              One-time payment · Free shipping · 180-Day Guarantee
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}